var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid grid-cols-12 lg:grid-cols-8 gap-5 lg:gap-8 justify-center"},[_c('MessagesList',{attrs:{"bookingsMessages":_vm.groupedMessages}}),_c('Conversation',{attrs:{"user":_vm.user}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }